export var getSlugFromUrl = function getSlugFromUrl() {
  if (typeof window === 'undefined') {
    return undefined;
  }
  var url = window.location.pathname;
  var segments = url.split('/');
  return segments.length >= 3 && segments[1] === 'org' ? segments[2] : undefined;
};